import { DevBoxSnapshot } from '../../models/dev-box';
import { createStringIdAdapter } from './common/string-id-adapter';

export const snapshotAdapter = createStringIdAdapter<DevBoxSnapshot>();
